import { ChangeDetectionStrategy, Component, Inject, Input, OnChanges, OnInit } from '@angular/core';
import { STREAMING_SERVICE_URI } from '@modules/video-player/video-player.module';

@Component({
  selector: 'app-media-content',
  templateUrl: './media-content.component.html',
  styleUrls: ['./media-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MediaContentComponent implements OnInit, OnChanges {
  @Input() public readonly mediaContainerWidth: string = '400px';
  @Input() public showOnlyPhoto: boolean;
  @Input() public readonly mediaContainerHeight: string = '718px';
  @Input() public readonly likesCount: number = null;
  @Input() public readonly commentsCount: number = null;
  @Input() public readonly inFavourites: boolean = null;
  @Input() public 'toolbar-mode' = 'vr';
  @Input() public containerStyle: { width: string; height: string } = null;
  @Input() public canOpenPhoto = false;
  @Input() public imageList: string[] = [];
  @Input() public housingPlans: string[] = [];
  @Input() public videoSource: string = null;
  @Input() public videoElementId: number = null;
  @Input() public playVideo = false;
  @Input() public prefix: string = null;
  @Input() public reserved: boolean;
  public mainPhoto: string;

  constructor(@Inject(STREAMING_SERVICE_URI) private streamingServiceUrl: string) {}

  public ngOnInit(): void {
    this.containerStyle = {
      width: this.mediaContainerWidth,
      height: this.mediaContainerHeight,
    };
  }

  public ngOnChanges(): void {
    if (this.showOnlyPhoto && this.videoSource) this.mainPhoto = `${this.streamingServiceUrl}${this.videoSource?.replace('/master.m3u8', '')}/thumbnail.png`;
  }

  public onError(): void {
    this.mainPhoto = '';
  }

  public get showMainPhoto(): boolean {
    return ((this.imageList && this.imageList.length > 0) || this.mainPhoto) && (!this.videoSource || this.showOnlyPhoto);
  }

  public get showNoPhoto(): boolean {
    return (!this.imageList || !this.imageList.length) && !this.mainPhoto && (!this.videoSource || this.showOnlyPhoto);
  }
}
